import {
  NavSideBarList,
} from 'StaticBuilder';
import ConnectedIowaBENInput from 'IowaBENInput';
import HelpSideBarButton from 'VisualStatic/HelpSideBarButton';
import DownloadOverlayManager from './download-overlay-manager';
import ConnectedHelpSideBar from '../../src-react/VisualStatic/ConnectedHelpSideBar';


window.NavSideBarList = NavSideBarList;
window.HelpSideBarButton = HelpSideBarButton;
window.ConnectedHelpSideBar = ConnectedHelpSideBar;
const OfferManager = require('offer-manager');
window.ProgressBar = require('progress-bar');

class VisualStatic {
  static redirectTo(uri) {
    window.location.href = uri;
  }

  static setupUnpaidExport() {
    const buttonSelectors = '.export-button-preview, #efileDocument';

    if (!window.SessionManager.showReactivationOffer) {
      // NON-PAYING users take them to the new account page
      $(buttonSelectors).each(function setUnpaidClickEvents() {
        $(this).attr('href', '#');
        $(this).attr('target', '');

        $(this).click(() => {
          const successAction = function unpaidExportSuccessAction() {
            // This is the default new account page url pulled from the preview modal.
            VisualStatic.redirectTo($('.proceed-to-export-upgrade').attr('href'));
          };
          window.SessionManager.save(successAction);
        });
      });
    } else {
      const om = new OfferManager();
      om.applyReactivationOffer(buttonSelectors);
    }
  }

  static addEFileButton() {
    // Add tax filing button
    const taxFilingURL = `/taxFiling.php${window.location.search}`;
    $('#exportButtons .btn-group').prepend(`<a id="efileDocument" href="${taxFilingURL}" class="btn" style="margin-left: 10px" href="#" target="_blank"><i class="icon icon-folder-open"></i> eFile Document</a>`);

    if (window.SessionManager.showReactivationOffer) {
      const om = new OfferManager();
      om.applyReactivationOffer('#efileDocument');
    }
  }

  static setTabOrder(orderOfFormFields) {
    for (let i = 0; i < orderOfFormFields.length; i += 1) {
      $(`[name='${orderOfFormFields[i]}']`).attr('tabindex', i + 1);
    }
  }

  static setPlaceholders(removeLabelsFromFields) {
    removeLabelsFromFields.forEach((field) => {
      $(`[name='${field}']`).attr('placeholder', '- Click To Add -');
    });
  }

  static initExportPDF() {
    // EXPORT PDF
    // Export to PDF logic for paying and non paying users
    if (window.SessionManager.isPaidUser) {
      // For PAYING users save and export the PDF
      $('.export-button-preview').click(() => {
        $('#instructionPane h1').text('Saving Document...');
        $('#instructionPane').modal('show');

        // Save the current form state, and download the PDF
        const successAction = function paidExportSuccessAction() {
          const offerManager = new window.OfferManager();
          offerManager.requestExport(() => {
            if (typeof window.FreemiumBox !== 'undefined') {
              window.FreemiumBox.deductCredit();
            }

            $('#saveBarObj').hide();
            setTimeout(() => {
              $('#instructionPane h1').text('Compiling Your PDF Document...');
            }, 1000);
            setTimeout(() => {
              $('#instructionPane').modal('hide');
            }, 5500);
            document.location = `/_api/fillAndExportPDFFromSession.php${document.location.search}`;
            DownloadOverlayManager.show();
          }, `/new-account-for-doc?${window.location.search.substr(1)}`, true);
        };
        window.SessionManager.save(successAction);
      });
    } else {
      VisualStatic.setupUnpaidExport(window.SessionManager.showReactivationOffer);
    }
  }

  constructor(showEFileButton = false) {
    this.showEFileButton = showEFileButton;
    this.orderOfFormFields = [];
  }

  initOnReactComponentsMounted() {
    const checkForMountedComponentsIntervalId = setInterval(() => {
      const allComponentsMounted = this.orderOfFormFields.reduce((mounted, fieldId) => (
        mounted && (document.querySelector(`[name="${fieldId}"]`) !== null)
      ), true);

      if (allComponentsMounted) {
        clearInterval(checkForMountedComponentsIntervalId);
        this.initBuilderOnReactComponentsMounted();
      }
    }, 100);
  }

  initBuilderOnReactComponentsMounted() {
    this.initBuilder();
  }

  initBuilder() {
    // Enter key is disabled from triggering a PDF export
    window.disableEnterKey = true;

    // Add the Progress Bar
    window.ProgressBar.init();
    $('body').on('change', window.ProgressBar.inputTypeText, window.ProgressBar.handleEvent);

    // Start auto-saving in the background
    window.SessionManager.autoSave.start();

    // ------------------- UI Modification

    // Force non-responsive display
    $('.row-fluid').addClass('row').removeClass('row-fluid');
    $('.builder .builder-content').css({ float: 'left' });

    // Hide all labels and replace them with placeholders
    $('form :input').each((index, elem) => {
      const eId = $(elem).attr('id');
      const elemLabel = $(elem).parents('form').find(`label[for=${eId}]`);
      const label = elemLabel.length === 1 ? elemLabel : null;

      if (eId && elemLabel) {
        $(elem).attr('placeholder', $(label).html());
        $(label).addClass('hide-label');
      }
    });

    // Remove the extra info from our loading modal
    $('#instructionPane .modal-body').html("<p>We're filling in your content, formatting, validating &amp; preparing your document</p>");
    $('#instructionPane .modal-footer').html(''); // There are a few Paragraphs here, hide all of them but keep the first.

    if (this.showEFileButton) {
      VisualStatic.addEFileButton();
    }

    // Remove the current preview functionality that comes with static docs
    $('.export-button-preview').attr('onclick', '');
    $('.export-button-preview').attr('href', '#');
    $('#exportToggle').hide();

    // For Paid users make the button text as Download PDF.
    if (window.SessionManager.isPaidUser) {
      $('.export-button-preview').html('<i class="icon icon-white icon-download-alt"></i> Download & Print PDF');
    }
  }

  static setUpIowaBENInput() {
    const payeeState = document.getElementById('payee1_state');
    window.ReactCompatibility.selectEfileState(payeeState.value);
    ConnectedIowaBENInput.init({ value: document.getElementById('payee1_ia_ben').value });

    // Create event handler for filing state in order to show/hide IA_BEN field
    ['change', 'input'].forEach((event) => {
      payeeState.addEventListener(
        event,
        () => {
          window.ReactCompatibility.selectEfileState(payeeState.value);
        },
      );
    });
  }

  static disableW2SelectDefaultOption() {
    const employmentType = document.getElementById('payee1_employment_type').firstChild;
    const kindOfEmployer = document.getElementById('payer_kind_of_employer').firstChild;
    employmentType.value = '';
    employmentType.disabled = true;
    kindOfEmployer.value = '';
    kindOfEmployer.disabled = true;
  }
}

module.exports = VisualStatic;



// WEBPACK FOOTER //
// ./src-assets/js/visual-static.js